/**
 * Placeholder for the admin tab(s) that are not built.
 *
 * Modelled on `eval/pages/EvalPlaceholderPage`. It names the blocker per tab instead
 * of saying "coming soon", because in every case the blocker is a missing service
 * capability rather than unwritten UI — and that is the thing someone reading this
 * page needs to know.
 */
import { Alert, Box, ContentLayout, Header, SpaceBetween, TextContent } from '@amzn/awsui-components-react';

/**
 * What each tab is waiting on, keyed by the ROUTE id.
 *
 * Keyed by id rather than by the visible label: the labels are translated, so
 * matching on them would silently fall through to the generic message as soon as
 * someone switches the UI to English.
 */
const BLOCKERS: Record<string, { what: string; blocker: string }> = {
  versions: {
    what: '整套推荐配置（决策树、项目参数、叠加关系、规则）的版本：一起审批、发布、回滚。',
    blocker:
      '目前只有「规则」有版本（在规则页上切换、提交、发布）。决策树还是 jar 里的问卷文件，项目参数改了立即生效，要先决定它们是否也走草稿和审批，才能设计整体版本。',
  },
};

export default function CpaPlaceholderPage({ page, pageId }: { page: string; pageId: string }) {
  const info = BLOCKERS[pageId];
  return (
    <ContentLayout header={<Header variant="h1">{page}</Header>}>
      <SpaceBetween size="m">
        {info ? (
          <Alert type="info" header="这一页还没有做，缺的不是界面">
            <TextContent>
              <p>
                <strong>要做成什么样：</strong>
                {info.what}
              </p>
              <p>
                <strong>卡在哪：</strong>
                {info.blocker}
              </p>
            </TextContent>
          </Alert>
        ) : (
          <Box color="text-status-inactive">这一页还没有做。</Box>
        )}
      </SpaceBetween>
    </ContentLayout>
  );
}
